import { useState, useEffect } from 'react';
import { getTspAlgorithms } from '../../../../Services';
import { DEFAULT_ALGORITHMS } from '../components/AlgorithmDetails';

export const useAlgorithms = () => {
  const [selectedAlgorithm, setSelectedAlgorithm] = useState('nearest_neighbor');
  const [algorithms, setAlgorithms] = useState(DEFAULT_ALGORITHMS);
  const [isLoadingAlgorithms, setIsLoadingAlgorithms] = useState(true);

  // Get algorithm information
  useEffect(() => {
    const fetchAlgorithms = async () => {
      setIsLoadingAlgorithms(true);
      try {
        const algorithmsData = await getTspAlgorithms();
        if (algorithmsData && algorithmsData.algorithms_info) {
          setAlgorithms(algorithmsData.algorithms_info);
          
          // If currently selected algorithm doesn't exist in newly fetched list, reset to default
          if (selectedAlgorithm && !algorithmsData.algorithms_info[selectedAlgorithm]) {
            setSelectedAlgorithm(algorithmsData.available_algorithms[0] || 'nearest_neighbor');
          }
        }
      } catch (error) {
        console.error('Failed to fetch algorithm information:', error);
        // Keep default algorithm
      } finally {
        setIsLoadingAlgorithms(false);
      }
    };
    
    fetchAlgorithms();
  }, [selectedAlgorithm]);

  const handleAlgorithmChange = (e) => {
    setSelectedAlgorithm(e.target.value);
  };

  const getAlgorithmOptions = () => {
    return Object.entries(algorithms).map(([value, info]) => (
      <option key={value} value={value}>
        {info.name}
      </option>
    ));
  };

  const algorithmInfo = algorithms[selectedAlgorithm] || algorithms['nearest_neighbor'];

  return {
    selectedAlgorithm,
    algorithms,
    isLoadingAlgorithms,
    handleAlgorithmChange,
    getAlgorithmOptions,
    algorithmInfo
  };
}; 